import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DAcRegistrationForm.css';
import React, { useEffect, useState } from 'react';
import { find, reduce, isEmpty } from 'lodash';
import { get, getDictionaryItem } from '../../../utils';
import { IconPlusCircle, IconDelete } from '../../atoms/Icons/';
import { Checkbox, TextInput, Select, RadioButtons } from '../../DAcApplication/components/StepsTemplates/components/FormFields';
import { GetLookupById, uploadConsent } from '../../DAcApplication/components/actions';
import Loader from '../../DAcApplication/components/loader';
import { getSessionId } from '../../DAcApplication/utils';
import { GetInvitationCodes } from '../../DAcApplication/components/actions';
var DacRegisterForm = function DacRegisterForm(_ref) {
  var dictionary = _ref.dictionary,
    configuration = _ref.configuration,
    apiConfig = _ref.apiConfig,
    redirectToBanner = _ref.redirectToBanner,
    rtl = _ref.rtl;
  var relationshipId = 'EA96BE9E75D8D3D690AEDAE5040EDF2F';
  var initialContext = {
    firstName: {
      value: '',
      name: 'firstName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'firstName'),
      required: true,
      isParent: true,
      valid: false
    },
    lastName: {
      value: '',
      name: 'lastName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'lastName'),
      required: true,
      isParent: true,
      valid: false
    },
    email: {
      value: '',
      name: 'email',
      type: 'email',
      label: getDictionaryItem(dictionary, 'emailAddress'),
      required: true,
      isParent: true,
      valid: false
    },
    marketingOptIn: {
      value: false,
      name: 'marketingOptIn',
      type: 'email',
      label: get(configuration, 'acceptEmailOrMessagesText.jss.value'),
      required: false,
      valid: false
    },
    privacyPolicy: {
      value: false,
      name: 'privacyPolicy',
      type: 'checkbox',
      label: get(configuration, 'acceptDGDPRAndPrivacyPolicyText.jss.value'),
      required: true,
      valid: false
    },
    familyApplication: {
      value: false,
      name: 'familyApplication',
      label: get(configuration, 'sectionTile.jss.value'),
      required: false,
      options: [{
        lookupId: false,
        name: {
          ar: getDictionaryItem(dictionary, 'no'),
          en: getDictionaryItem(dictionary, 'no')
        }
      }, {
        lookupId: true,
        name: {
          ar: getDictionaryItem(dictionary, 'yes'),
          en: getDictionaryItem(dictionary, 'yes')
        }
      }]
    }
  };
  var siblingsContextInitial = {
    firstName: {
      value: '',
      name: 'firstName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'firstName'),
      required: true,
      valid: false
    },
    lastName: {
      value: '',
      name: 'lastName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'lastName'),
      required: true,
      valid: false
    },
    relation: {
      value: '',
      name: 'relation',
      type: 'select',
      label: getDictionaryItem(dictionary, 'relationship'),
      required: true,
      valid: false
    }
  };
  var apiKey = apiConfig.apiKey,
    apiUrl = apiConfig.apiUrl;
  var sessionId = getSessionId('');
  var _useState = useState(initialContext),
    _useState2 = _slicedToArray(_useState, 2),
    context = _useState2[0],
    setContext = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    siblingsContext = _useState4[0],
    setSiblingsContext = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    relationshipList = _useState6[0],
    setRelationshipList = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    submitting = _useState8[0],
    setSubmitting = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    submitError = _useState10[0],
    setSubmitError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    disableSubmit = _useState12[0],
    setDisableSubmit = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    validateParentRule = _useState14[0],
    setValidateRequireRule = _useState14[1];
  var updateContext = function updateContext(data) {
    setContext(function (state) {
      return _objectSpread(_objectSpread({}, state), data);
    });
  };
  var updateSiblingConext = function updateSiblingConext(data, key) {
    setSiblingsContext(siblingsContext.map(function (item, index) {
      if (index == key) return _objectSpread(_objectSpread({}, item), data);
      return item;
    }));
  };
  var addSiblingItem = function addSiblingItem() {
    setSiblingsContext(function (state) {
      return [].concat(_toConsumableArray(state), [siblingsContextInitial]);
    });
  };
  var removeSiblingItem = function removeSiblingItem(index) {
    setSiblingsContext(function (state) {
      return state.filter(function (item, i) {
        return index != i;
      });
    });
  };
  var formSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var data, _yield$GetInvitationC, _yield$GetInvitationC2, Success, error, errorMessage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setSubmitError('');
            setSubmitting(true);
            _context.next = 5;
            return collectData();
          case 5:
            data = _context.sent;
            _context.next = 8;
            return GetInvitationCodes({
              apiKey: apiKey,
              apiUrl: apiUrl,
              sessionId: sessionId
            }, data);
          case 8:
            _yield$GetInvitationC = _context.sent;
            _yield$GetInvitationC2 = _yield$GetInvitationC.Success;
            Success = _yield$GetInvitationC2 === void 0 ? false : _yield$GetInvitationC2;
            error = _yield$GetInvitationC.error;
            setSubmitting(false);
            console.log(Success, error);
            if (isEmpty(error)) {
              _context.next = 18;
              break;
            }
            errorMessage = rtl && error.ar ? error.ar : error.en || '';
            setSubmitError(errorMessage.replaceAll(',', '\n'));
            return _context.abrupt("return");
          case 18:
            if (!Success) {
              _context.next = 22;
              break;
            }
            _context.next = 21;
            return uploadConsent({
              apiKey: apiKey,
              sessionId: sessionId
            }, {
              email: data.submitter.email,
              firstName: data.submitter.firstName,
              lastName: data.submitter.lastName,
              url: window.location.href,
              consent: data.marketingOptIn
            });
          case 21:
            redirectToBanner(true, context['email'].value);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function formSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var collectData = function collectData() {
    var dataMapping = [{
      name: 'submitter',
      fields: ['firstName', 'lastName', 'email'],
      isChildrens: true
    }, {
      name: 'familyApplication',
      fields: ['familyApplication']
    }, {
      name: 'marketingOptIn',
      fields: ['marketingOptIn']
    }, {
      name: 'privacyPolicy',
      fields: ['privacyPolicy']
    }, {
      name: 'applicants',
      fields: ['firstName', 'lastName', 'relation'],
      isArray: true
    }];
    var submitData = reduce(dataMapping, function (data, _ref3) {
      var name = _ref3.name,
        fields = _ref3.fields,
        isArray = _ref3.isArray,
        isChildrens = _ref3.isChildrens;
      if (!isArray) {
        data[name] = {};
        console.log(name, fields);
        fields.forEach(function (fieldName) {
          console.log(fieldName, data);
          return isChildrens ? data[name][fieldName] = context[fieldName].value : data[fieldName] = context[fieldName].value;
        });
      } else {
        data[name] = [];
        siblingsContext.forEach(function (siblingGroupField) {
          var siblingGroupData = reduce(fields, function (acc, fieldName) {
            acc[fieldName] = siblingGroupField[fieldName].value;
            return acc;
          }, {});
          console.log(siblingGroupData);
          data[name].push(siblingGroupData);
        });
      }
      return data;
    }, {});
    console.log(submitData);
    submitData.otherDetails = {
      hiddenCity: '',
      hiddenCountryCode: '',
      hiddenNetwork: '',
      hiddenTimeZone: '',
      utmCampaign: '',
      utmContent: '',
      utmMedium: '',
      utmSource: '',
      utmTerm: '',
      sourceURL: ''
    };
    return submitData;
  };
  useEffect(function () {
    function fetchRelationship() {
      return _fetchRelationship.apply(this, arguments);
    }
    function _fetchRelationship() {
      _fetchRelationship = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return GetLookupById({
                apiKey: apiKey,
                apiUrl: apiUrl,
                sessionId: sessionId,
                lookupid: relationshipId
              });
            case 2:
              response = _context2.sent;
              setRelationshipList(response || []);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _fetchRelationship.apply(this, arguments);
    }
    fetchRelationship();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    var isInvalidParent = find(context, function (_ref4) {
      var required = _ref4.required,
        valid = _ref4.valid,
        _ref4$isParent = _ref4.isParent,
        isParent = _ref4$isParent === void 0 ? false : _ref4$isParent;
      return required && isParent && !valid;
    });
    setValidateRequireRule(!isInvalidParent);
  }, [context]);
  useEffect(function () {
    if (validateParentRule) {
      var invalidFieldChildren = siblingsContext.find(function (siblingGroupField) {
        return find(siblingGroupField, function (_ref5) {
          var required = _ref5.required,
            valid = _ref5.valid;
          return required && !valid;
        });
      });
      var invalidField = find(context, function (_ref6) {
        var required = _ref6.required,
          valid = _ref6.valid;
        return required && !valid;
      });
      setDisableSubmit(!!invalidField || !!invalidFieldChildren);
    } else {
      setDisableSubmit(true);
    }
  }, [validateParentRule, siblingsContext, context]);
  useEffect(function () {
    if (context.familyApplication.value) {
      addSiblingItem();
    } else {
      setSiblingsContext([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.familyApplication.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, /*#__PURE__*/React.createElement("form", {
    className: "dac-login-form",
    onSubmit: formSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap  "
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['firstName'], {
    updateContext: updateContext,
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap  "
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['lastName'], {
    updateContext: updateContext,
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap  "
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['email'], {
    updateContext: updateContext,
    rtl: rtl
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12  "
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap radio-field"
  }, /*#__PURE__*/React.createElement(RadioButtons, _extends({}, context['familyApplication'], {
    updateContext: updateContext,
    rtl: rtl,
    isBoolean: true
  })))), context.familyApplication.value == '1' && /*#__PURE__*/React.createElement("div", {
    className: " col-12 "
  }, /*#__PURE__*/React.createElement("p", {
    className: "fields-group-title"
  }, " ", getDictionaryItem(dictionary, 'familyMemberDetails')), siblingsContext.map(function (prop, index) {
    return /*#__PURE__*/React.createElement(SiblingFieldList, {
      key: index,
      context: prop,
      relationshipList: relationshipList,
      dataKeyProperty: index,
      updateContext: updateSiblingConext,
      removeSiblingItem: removeSiblingItem,
      rtl: rtl,
      title: getDictionaryItem(dictionary, 'memberDetails')
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary dac-add-btn",
    onClick: function onClick(e) {
      e.preventDefault();
      addSiblingItem();
    }
  }, /*#__PURE__*/React.createElement(IconPlusCircle, null), /*#__PURE__*/React.createElement("span", null, getDictionaryItem(dictionary, 'addMember'))))), validateParentRule && /*#__PURE__*/React.createElement("div", {
    className: "col-12 group-checkbox"
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, context['marketingOptIn'], {
    updateContext: updateContext,
    rtl: rtl
  })), /*#__PURE__*/React.createElement(Checkbox, _extends({}, context['privacyPolicy'], {
    updateContext: updateContext,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__submit-wrapper col-12 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-failed-wrap"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit dac-login-btn",
    type: "submit",
    disabled: disableSubmit
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: submitting ? 0 : 1
    }
  }, getDictionaryItem(dictionary, 'registerNow')), submitting ? /*#__PURE__*/React.createElement(Loader, null) : false), submitError && /*#__PURE__*/React.createElement("b", {
    className: "request-failed"
  }, submitError))))));
};
var SiblingFieldList = function SiblingFieldList(_ref7) {
  var context = _ref7.context,
    _updateContext = _ref7.updateContext,
    rtl = _ref7.rtl,
    relationshipList = _ref7.relationshipList,
    dataKeyProperty = _ref7.dataKeyProperty,
    removeSiblingItem = _ref7.removeSiblingItem,
    title = _ref7.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs fields-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fields-group-subtitle"
  }, title, " ", dataKeyProperty + 1, /*#__PURE__*/React.createElement("span", {
    className: "divider"
  }), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return removeSiblingItem(dataKeyProperty);
    },
    className: "dac-remove-btn"
  }, /*#__PURE__*/React.createElement(IconDelete, null)))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap"
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['firstName'], {
    updateContext: function updateContext(newContext) {
      return _updateContext(newContext, dataKeyProperty);
    },
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap "
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['lastName'], {
    updateContext: function updateContext(newContext) {
      return _updateContext(newContext, dataKeyProperty);
    },
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-elements-wrap "
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['relation'], {
    updateContext: function updateContext(newContext) {
      return _updateContext(newContext, dataKeyProperty);
    },
    rtl: rtl,
    options: relationshipList,
    isString: true
  })))));
};
export default DacRegisterForm;
var commonStyles = "c1k0dmwr";
var ltrStyles = "ldz9ma7";
var rtlStyles = "r8w2h5x";